export default __webpack_public_path__ + "static/media/flag-guinea-bissau.c9841c5b.svg";